module.exports = __webpack_public_path__ + "static/media/algae1.2bde4d61.svg";